const MISSING_FILE_PATH_FALLBACK = "File path not available";

export const getAssetFilePathOrDefault = (filePath?: string, fallback = MISSING_FILE_PATH_FALLBACK): string =>
    !!filePath ? filePath : fallback;
